import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { ADLNeedsQuestionnaireItem } from './questionnaire'

export const ADL_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [ADLNeedsQuestionnaireItem.ADL_NEEDS]: QuestionnaireAnswerType.GROUP,
  [ADLNeedsQuestionnaireItem.ADL_NEEDS_NEED]: QuestionnaireAnswerType.GROUP,
  [ADLNeedsQuestionnaireItem.ADL_NEEDS_NEED_ID]: QuestionnaireAnswerType.STRING,
  [ADLNeedsQuestionnaireItem.ADL_NEEDS_NEED_OBSERVATION_REFERENCE]:
    QuestionnaireAnswerType.REFERENCE,
  [ADLNeedsQuestionnaireItem.ADL_NEEDS_NEED_NAME]: QuestionnaireAnswerType.STRING,
  [ADLNeedsQuestionnaireItem.ADL_NEEDS_NEED_NEW_NOTE]: QuestionnaireAnswerType.STRING,
  [ADLNeedsQuestionnaireItem.ADL_NEEDS_NEED_IS_ARCHIVED]: QuestionnaireAnswerType.BOOLEAN,
  [ADLNeedsQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_AUTHOR]: QuestionnaireAnswerType.STRING,
  [ADLNeedsQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_DATE]: QuestionnaireAnswerType.DATE,
  [ADLNeedsQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_TEXT]: QuestionnaireAnswerType.STRING
}
